/** Explains each limit type, shown as the subtitle of its section */
export const limitTooltips = {
  ["user_role"]: <>
      Every member with an admin, manager or editor role automatically gets a
      Sphere XG seat.
      <p>
        At the workspace level, this includes all admins, group managers and
        project managers.
      </p>
      <p>At the project level, this includes all admins and editors.</p>
      <p>
        Members invited with these roles count towards this limit even while
        their invitation is pending.
      </p>
      <p>
        To remove a member&apos;s Sphere XG seat, remove all their admin,
        manager and editor roles. You can do this on the member&apos;s profile
        page.
      </p>
    </>,
  ["project_area"]: <>
      Specifies the total area (in sq ft) that can be allocated to active
      projects. Archived projects are excluded from this calculation.
    </>,
  ["storage"]: <>
      The total amount of data space used across all projects, including both
      active and archived projects.
    </>,
  ["project_count"]: <>
      The total amount of active projects in the workspace. Archived projects
      are excluded from this calculation.
    </>
};